export default function() {
  var size = 0;
  this.visit(function(node) {
    if (!node.length) do ++size; while (node = node.next)
  });
  return size;
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-quadtree/src/size.js
// module id = ../../../../d3-quadtree/src/size.js
// module chunks = 4